// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-OrganizationChart-DetailPage-___LeftSection-module__container {
  position: relative;
  width: 200px;
}

.app-components-OrganizationChart-DetailPage-___LeftSection-module__container:hover .app-components-OrganizationChart-DetailPage-___LeftSection-module__overlay {
  opacity: 0.8;
}

.app-components-OrganizationChart-DetailPage-___LeftSection-module__picture {
  height: 250px;
  width: 200px;
  background-position: center;
  background-size: cover;
  position: relative;
}

.app-components-OrganizationChart-DetailPage-___LeftSection-module__overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.3s ease;
  background-color: rgba(139, 139, 139);
  transform: translate(-50%, -50%);
  border-radius: 0.5rem;
}

.app-components-OrganizationChart-DetailPage-___LeftSection-module__icon {
  color: white;
  font-size: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%);
  cursor: pointer;
}

.app-components-OrganizationChart-DetailPage-___LeftSection-module__icon :first-child {
    width: 60px;
    margin-left: -30px;
  }

.app-components-OrganizationChart-DetailPage-___LeftSection-module__faUser:hover {
  color: #eee;
}

.app-components-OrganizationChart-DetailPage-___LeftSection-module__leftSection {
  margin-top: 20px;
  margin-right: 50px;
  width: 100%;
}

.app-components-OrganizationChart-DetailPage-___LeftSection-module__topLeftSection {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-width: 100%;
}

.app-components-OrganizationChart-DetailPage-___LeftSection-module__name {
  font-size: 22px;
  font-weight: bold;
}

.app-components-OrganizationChart-DetailPage-___LeftSection-module__leftList {
  padding-inline-start: 0;
  width: 100%;
}

.app-components-OrganizationChart-DetailPage-___LeftSection-module__leftList .app-components-OrganizationChart-DetailPage-___LeftSection-module__listItems {
    display: flex;
    justify-content: flex-start;
    padding-bottom: 10px;
  }

.app-components-OrganizationChart-DetailPage-___LeftSection-module__leftList .app-components-OrganizationChart-DetailPage-___LeftSection-module__listItems .app-components-OrganizationChart-DetailPage-___LeftSection-module__listItemsTitle {
      font-weight: bold;
      padding-right: 10px;
    }

.app-components-OrganizationChart-DetailPage-___LeftSection-module__leftList .app-components-OrganizationChart-DetailPage-___LeftSection-module__listItems p,
    .app-components-OrganizationChart-DetailPage-___LeftSection-module__leftList .app-components-OrganizationChart-DetailPage-___LeftSection-module__listItems input {
      height: 25px;
    }

.app-components-OrganizationChart-DetailPage-___LeftSection-module__leftList .app-components-OrganizationChart-DetailPage-___LeftSection-module__listItems input {
      padding-left: 5px;
      padding-right: 5px;
    }
`, "",{"version":3,"sources":["webpack://./app/components/OrganizationChart/DetailPage/LeftSection.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,UAAU;EACV,qBAAqB;EACrB,qCAAqC;EACrC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;AAMjB;;AAJE;IACE,WAAW;IACX,kBAAkB;EACpB;;AAGF;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AAsBb;;AApBE;IACE,aAAa;IACb,2BAA2B;IAC3B,oBAAoB;EAgBtB;;AAdE;MACE,iBAAiB;MACjB,mBAAmB;IACrB;;AAEA;;MAEE,YAAY;IACd;;AAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB","sourcesContent":[".container {\n  position: relative;\n  width: 200px;\n}\n\n.container:hover .overlay {\n  opacity: 0.8;\n}\n\n.picture {\n  height: 250px;\n  width: 200px;\n  background-position: center;\n  background-size: cover;\n  position: relative;\n}\n\n.overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  transition: 0.3s ease;\n  background-color: rgba(139, 139, 139);\n  transform: translate(-50%, -50%);\n  border-radius: 0.5rem;\n}\n\n.icon {\n  color: white;\n  font-size: 100px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -55%);\n  cursor: pointer;\n\n  :first-child {\n    width: 60px;\n    margin-left: -30px;\n  }\n}\n\n.faUser:hover {\n  color: #eee;\n}\n\n.leftSection {\n  margin-top: 20px;\n  margin-right: 50px;\n  width: 100%;\n}\n\n.topLeftSection {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  min-width: 100%;\n}\n\n.name {\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.leftList {\n  padding-inline-start: 0;\n  width: 100%;\n\n  .listItems {\n    display: flex;\n    justify-content: flex-start;\n    padding-bottom: 10px;\n\n    .listItemsTitle {\n      font-weight: bold;\n      padding-right: 10px;\n    }\n\n    p,\n    input {\n      height: 25px;\n    }\n\n    input {\n      padding-left: 5px;\n      padding-right: 5px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-components-OrganizationChart-DetailPage-___LeftSection-module__container`,
	"overlay": `app-components-OrganizationChart-DetailPage-___LeftSection-module__overlay`,
	"picture": `app-components-OrganizationChart-DetailPage-___LeftSection-module__picture`,
	"icon": `app-components-OrganizationChart-DetailPage-___LeftSection-module__icon`,
	"faUser": `app-components-OrganizationChart-DetailPage-___LeftSection-module__faUser`,
	"leftSection": `app-components-OrganizationChart-DetailPage-___LeftSection-module__leftSection`,
	"topLeftSection": `app-components-OrganizationChart-DetailPage-___LeftSection-module__topLeftSection`,
	"name": `app-components-OrganizationChart-DetailPage-___LeftSection-module__name`,
	"leftList": `app-components-OrganizationChart-DetailPage-___LeftSection-module__leftList`,
	"listItems": `app-components-OrganizationChart-DetailPage-___LeftSection-module__listItems`,
	"listItemsTitle": `app-components-OrganizationChart-DetailPage-___LeftSection-module__listItemsTitle`
};
export default ___CSS_LOADER_EXPORT___;
